import { Action, createReducer, on } from '@ngrx/store';

import * as ParcelActions from './parcel.actions';

export const parcelFeatureKey = 'parcel';

export interface ParcelState {
  forestryKml: Array<any>;
}

export const initialState: ParcelState = {
  forestryKml: [],
};

const parcelReducer = createReducer(
  initialState,
  on(ParcelActions.setForestryKml, (state, forestryStands) => ({
    ...state,
    forestryKml: forestryStands.data,
  })),
  on(ParcelActions.clearAll, state => {
    return {
      ...initialState,
    };
  }),
);

export function reducer(state: ParcelState | undefined, action: Action) {
  return parcelReducer(state, action);
}
